DialogController = App.loadClass 'core::Angular/DialogController'

class exports.SurveyFieldsDialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @repo, survey_result) ->
        super(@scope, @transitions, @modalInstance)

        sr = survey_result # just for convenience
        num_plans = Object.keys(sr.planned_fields).length
        @scope.title = "#{sr.pp_name} (#{num_plans}/#{sr.num_fields}) #{sr.date}"

        @scope.placeholder = 'Loading field list...'
        @scope.fields = []

        @loadSurveyFields(survey_result)

    loadSurveyFields: (survey_result) =>
        @repo.getSurveyFields(survey_result).then (result) =>
            if result.data?.status?.type isnt 'success'
                if result.data?.status?
                    @scope.setAlert(result.data?.status)
                else
                    @scope.setAlert
                        type: 'error'
                        msg: 'Failed to load field list for this survey result'
                return

            @scope.fields = result.data.data.fields
            if @scope.fields.length is 0
                @scope.placeholder = 'No fields found'

        , () =>
            # if the request failed
            @scope.setAlert
                type: 'error'
                msg: 'Failed to load field list for this survey result'
